import React from "react";
import "./permissionsSwitchbtn.css";

const PermissionsSwitchButton = ({ label, isActive = false, onToggle }) => {
  return (
    <div className="permission-switch-container d-flex align-items-center">
      <div
        className={`switch-button-permissions ${isActive ? "active" : "inactive"}`}
        onClick={() => onToggle && onToggle(!isActive)}
      >
        <div className="switch-knob-permissions"></div>
      </div>
      <div className="permission-label">
        <p className="fs16 semibold darkGrey mb-0">{label}</p>
      </div>
    </div>
  );
};

export default PermissionsSwitchButton;
